import React from 'react';
import '../template-file-css/document-file-template.css';


export const GENERAL_Bps = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='GENERAL_Bps' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    <h1> <center> Intake Note </center> </h1>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Presenting Problem</span>
                    <textarea id='txtPresentingProblem' name='txtPresentingProblem' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <b> Current Mental Status </b>
                </p>


                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>1. Orientation:</span></td>
                        <td className='w-375'><span className='eleHeader'>2. General Appearance:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <select id='ddlOrientation' name='ddlOrientation' className='add-only'>
                                <option value='NA'> </option>
                                <option value='X3: Oriented to Person, Place, and Time'> X3: Oriented to Person, Place, and Time </option>
                                <option value='X2: Oriented to Person, Place; Impaired to Time'> X2: Oriented to Person, Place; Impaired to Time </option>
                                <option value='X2: Oriented to Person, Time; Impaired to Place'> X2: Oriented to Person, Time; Impaired to Place </option>
                                <option value='X2: Oriented to Time, Place; Impaired to Person'> X2: Oriented to Time, Place; Impaired to Person </option>
                                <option value='X1: Oriented to Person; Impaired to Place, Time'> X1: Oriented to Person; Impaired to Place, Time </option>
                                <option value='X1: Oriented to Place; Impaired to Person, Time'> X1: Oriented to Place; Impaired to Person, Time </option>
                                <option value='X1: Oriented to Time; Impaired to Person, Place'> X1: Oriented to Time; Impaired to Person, Place </option>
                                <option value='X0: Impaired to Person, Place, and Time'> X0: Impaired to Person, Place, and Time </option>
                                <option value='Not Assessed'> Not Assessed </option>
                            </select>

                        </td>
                        <td className='w-375'>
                            <select id='ddlGeneralAppearance' name='ddlGeneralAppearance' className='add-only'>
                                <option value='NA'> </option>
                                <option value='Appropriate'> Appropriate </option>
                                <option value='Disheveled'> Disheveled </option>
                                <option value='Emaciated'> Emaciated </option>
                                <option value='Obese'> Obese </option>
                                <option value='Poor Hygiene'> Poor Hygiene </option>
                                <option value='Not Assessed'> Not Assessed </option>
                            </select>

                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>3. Dress: </span></td>
                        <td className='w-375'><span className='eleHeader'>4. Motor Activity: </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <select id='ddlDress' name='ddlDress' className='add-only'>
                                <option value='NA'> </option>
                                <option value='Appropriate'> Appropriate </option>
                                <option value='Eccentric'> Eccentric </option>
                                <option value='Seductive'> Seductive </option>
                                <option value='Bizarre'> Bizarre </option>
                                <option value='Not Assessed'> Not Assessed </option>
                            </select>

                        </td>
                        <td className='w-375'>
                            <select id='ddlMotorActivity' name='ddlMotorActivity' className='add-only'>
                                <option value='NA'> </option>
                                <option value='Unremarkable'> Unremarkable </option>
                                <option value='Agitation'> Agitation </option>
                                <option value='Retardation'> Retardation </option>
                                <option value='Posturing'> Posturing </option>
                                <option value='Repetitive Actions'> Repetitive Actions </option>
                                <option value='Tics'> Tics </option>
                                <option value='Tremor'> Tremor </option>
                                <option value='Unusual Gait'> Unusual Gait </option>
                                <option value='Not Assessed'> Not Assessed </option>
                            </select>

                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>5. Interview Behavior:</span></td>
                        <td className='w-375'><span className='eleHeader'>6. Speech:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <select id='ddlInterviewBehavior' name='ddlInterviewBehavior' className='add-only'>
                                <option value='NA'> </option>
                                <option value='Appropriate'> Appropriate </option>
                                <option value='Aggressive'> Aggressive </option>
                                <option value='Angery'> Angry </option>
                                <option value='Apathetic'> Apathetic </option>
                                <option value='Argumentative'> Argumentative </option>
                                <option value='Child-like'> Child-like </option>
                                <option value='Demanding'> Demanding </option>
                                <option value='Drastic'> Drastic </option>
                                <option value='Evasive'> Evasive </option>
                                <option value='Hostile'> Hostile </option>
                                <option value='Irritable'> Irritable </option>
                                <option value='Passive'> Passive </option>
                                <option value='Manipulative'> Manipulative </option>
                                <option value='Withdrawn'> Withdrawn </option>
                                <option value='Uncooperative'> Uncooperative </option>
                                <option value='Not Assessed'> Not Assessed </option>
                            </select>

                        </td>
                        <td className='w-375'>
                            <select id='ddlSpeech' name='ddlSpeech' className='add-only'>
                                <option value='NA'> </option>
                                <option value='Normal'> Normal </option>
                                <option value='Hesitant'> Hesitant </option>
                                <option value='Pressured'> Pressured </option>
                                <option value='Slurred'> Slurred </option>
                                <option value='Soft'> Soft </option>
                                <option value='Stuttering'> Stuttering </option>
                                <option value='Mute'> Mute </option>
                                <option value='Verbose'> Verbose </option>
                                <option value='Not Assessed'> Not Assessed </option>
                            </select>

                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>7. Mood:</span></td>
                        <td className='w-375'><span className='eleHeader'>8. Affect:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <select id='ddlMood' name='ddlMood' className='add-only'>
                                <option value='NA'> </option>
                                <option value='Euthymic'> Euthymic </option>
                                <option value='Dysphoric'> Dysphoric </option>
                                <option value='Depressed'> Depressed </option>
                                <option value='Euphoric'> Euphoric </option>
                                <option value='Grandiose'> Grandiose </option>
                                <option value='Anxious'> Anxious </option>
                                <option value='Labile'> Labile </option>
                                <option value='Irritable'> Irritable </option>
                                <option value='Angry'> Angry </option>
                                <option value='Not Assessed'> Not Assessed </option>
                            </select>

                        </td>
                        <td className='w-375'>
                            <select id='ddlAffect' name='ddlAffect' className='add-only'>
                                <option value='NA'> </option>
                                <option value='Congruent'> Congruent </option>
                                <option value='Incongruent'> Incongruent </option>
                                <option value='Appropriate'> Appropriate </option>
                                <option value='Inappropriate'> Inappropriate </option>
                                <option value='Reactive'> Reactive </option>
                                <option value='Constricted'> Constricted </option>
                                <option value='Blunted'> Blunted </option>
                                <option value='Flat'> Flat </option>
                                <option value='Not Assessed'> Not Assessed </option>
                            </select>

                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>9. Insight:</span></td>
                        <td className='w-375'><span className='eleHeader'>10. Judgement/Impulse Control:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <select id='ddlInsight' name='ddlInsight' className='add-only'>
                                <option value='NA'> </option>
                                <option value='Excellent'> Excellent </option>
                                <option value='Good'> Good </option>
                                <option value='Fair'> Fair </option>
                                <option value='Poor'> Poor </option>
                                <option value='Nil'> Nil </option>
                                <option value='Not Assessed'> Not Assessed </option>
                            </select>

                        </td>
                        <td className='w-375'>
                            <select id='ddlJudgementImpulsControl' name='ddlJudgementImpulseControl' className='add-only'>
                                <option value='NA'> </option>
                                <option value='Excellent'> Excellent </option>
                                <option value='Good'> Good </option>
                                <option value='Fair'> Fair </option>
                                <option value='Poor'> Poor </option>
                                <option value='Nil'> Nil </option>
                                <option value='Not Assessed'> Not Assessed </option>
                            </select>

                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>11. Memory:</span></td>
                        <td className='w-375'><span className='eleHeader'>12. Attention/Concentration:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <select id='ddlMemory' name='ddlMemory' className='add-only'>
                                <option value='NA'> </option>
                                <option value='Intact'> Intact </option>
                                <option value='Poor Remote'> Poor Remote </option>
                                <option value='Poor Recent'> Poor Recent </option>
                                <option value='Not Assessed'> Not Assessed </option>
                            </select>

                        </td>
                        <td className='w-375'>
                            <select id='ddlAttentionConcentration' name='ddlAttentionConcentration' className='add-only'>
                                <option value='NA'> </option>
                                <option value='Good'> Good </option>
                                <option value='Distractible'> Distractible </option>
                                <option value='Variable'> Variable </option>
                                <option value='Not Assessed'> Not Assessed </option>
                            </select>

                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>13. Thought Process:</span></td>
                        <td className='w-375'><span className='eleHeader'>14. Thought Content:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <select id='ddlThoughtProcess' name='ddlThoughtProcess' className='add-only'>
                                <option value='NA'> </option>
                                <option value='Unremarkable'> Unremarkable </option>
                                <option value='Blocking'> Blocking </option>
                                <option value='Circumstantial'> Circumstantial </option>
                                <option value='Flight Of Ideas'> Flight Of Ideas </option>
                                <option value='Loose Associations'> Loose Associations </option>
                                <option value='Perseveration'> Perseveration </option>
                                <option value='Tangential'> Tangential </option>
                                <option value='Not Assessed'> Not Assessed </option>
                            </select>

                        </td>
                        <td className='w-375'>
                            <select id='ddlThoughtContent' name='ddlThoughtContent' className='add-only'>
                                <option value='NA'> </option>
                                <option value='Appropriate'> Appropriate </option>
                                <option value='Preoccupied'> Preoccupied </option>
                                <option value='Obsessions'> Obsessions </option>
                                <option value='Delusions: Persecutory'> Delusions: Persecutory </option>
                                <option value='Delusions: Bizarre'> Delusions: Bizarre </option>
                                <option value='Delusions: Grandeur'> Delusions: Grandeur </option>
                                <option value='Delusions: Guilt'> Delusions: Guilt </option>
                                <option value='Delusions: Somatic'> Delusions: Somatic </option>
                                <option value='Delusions: Ideas of Reference'> Delusions: Ideas of Reference </option>
                                <option value='Delusions: Thought Broadcasting'> Delusions: Thought Broadcasting </option>
                                <option value='Delusions: Thought Control'> Delusions: Thought Control </option>
                                <option value='Not Assessed'> Not Assessed </option>
                            </select>

                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>15. Perception:</span></td>
                        <td className='w-375'><span className='eleHeader'>16. Functional Status:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <select id='ddlPerception' name='ddlPerception' className='add-only'>
                                <option value='NA'> </option>
                                <option value='Unremarkable'> Unremarkable </option>
                                <option value='Auditory Hallucinations'> Auditory Hallucinations </option>
                                <option value='Visual Hallucinations'> Visual Hallucinations </option>
                                <option value='Olfactory Hallucinations'> Olfactory Hallucinations </option>
                                <option value='Tactile Hallucinations'> Tactile Hallucinations </option>
                                <option value='Gustatory Hallucinations'> Gustatory Hallucinations </option>
                                <option value='Not Assessed'> Not Assessed </option>
                            </select>

                        </td>
                        <td className='w-375'>
                            <select id='ddlFunctionalStatus' name='ddlFunctionalStatus' className='add-only'>
                                <option value='NA'> </option>
                                <option value='Positive social support'> Positive social support </option>
                                <option value='Mildly Impaired'> Mildly Impaired </option>
                                <option value='Moderately Impaired'> Moderately Impaired </option>
                                <option value='Severely Impaired'> Severely Impaired </option>
                                <option value='Variably Impaired'> Variably Impaired </option>
                                <option value='Not Assessed'> Not Assessed </option>
                            </select>

                        </td>
                    </tr>

                </table>


                <p className='w-750'>
                    <b> Risk Assessment </b>
                    <br />

                    <input type='checkbox' id='cbRiskAssessment' name='cbRiskAssessment' className='add-only' value='RiskAssessment' /> Patient denies all areas of risk. No contrary clinical indications present.

                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Area of Risk:</span>
                    <select id='ddlAreaRisk' name='ddlAreaRisk' className='add-only'>
                        <option value='NA'></option>
                        <option value='SuicidlIdeation'> Suicidl ideation </option>
                        <option value='HomicidalIdeation'> Homicidal ideation </option>
                        <option value='InabilitySelf'> Inability to care for self </option>
                        <option value='InabilityOthers'> Inability to care for others </option>
                        <option value='AgressionOthers'> Agression toward others </option>
                        <option value='AgressionProperty'> Agression toward property </option>
                        <option value='SelfHarm'> self-harm </option>
                        <option value='Elopement'> Elopement</option>
                        <option value='SubstanceMisuse'> Substance Misuse </option>
                    </select>
                </p>

                <table>

                    <tr>
                        <td className='w-375'><span className='eleHeader'>Level of Risk:</span></td>
                        <td className='w-375'><span className='eleHeader'>Intent to Act :</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbLevelRisk_Low' name='rbLevelRisk' className='add-only' value='Low' /> Low &nbsp;
                            <input type='radio' id='rbLevelRisk_Medium' name='rbLevelRisk' className='add-only' value='Medium' /> Medium &nbsp;
                            <input type='radio' id='rbLevelRisk_High' name='rbLevelRisk' className='add-only' value='High' /> High &nbsp;
                            <input type='radio' id='rbLevelRisk_Imminent' name='rbLevelRisk' className='add-only' value='Imminent' /> Imminent
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbIntentAct_Yes' name='rbIntentAct' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbIntentAct_No' name='rbIntentAct' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbIntentAct_Not Applicable' name='rbIntentAct' className='add-only' value='Not Applicable' /> Not Applicable
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Plan to Act:</span></td>
                        <td className='w-375'><span className='eleHeader'> Means to Act:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbPlanAct_Yes' name='rbPlanAct' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbPlanAct_No' name='rbPlanAct' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbPlanAct_Not Applicable' name='rbPlanAct' className='add-only' value='Not Applicable' /> Not Applicable
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbMeansAct_Yes' name='rbMeansAct' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbMeansAct_No' name='rbMeansAct' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbMeansAct_Not Applicable' name='rbMeansAct' className='add-only' value='Not Applicable' /> Not Applicable
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Risk Factors:</span></td>
                        <td className='w-375'><span className='eleHeader'>Protective Factors:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <select id='ddlRiskFactors' name='ddlRiskFactors' className='add-only'>
                                <option value='NA'> </option>
                                <option value='Current ideation'> Current ideation </option>
                                <option value='Access to means'> Access to means </option>
                                <option value='History of attempts/behaviors'> History of attempts/behaviors </option>
                                <option value='Alcohol/Substance use'> Alcohol/Substance use </option>
                                <option value='Impulsivity'> Impulsivity </option>
                                <option value='Hopelessness'> Hopelessness </option>
                                <option value='Recent loss'> Recent loss </option>
                                <option value='Family history'> Family history </option>
                            </select>

                        </td>
                        <td className='w-375'>
                            <select id='ddlProtectiveFactors' name='ddlProtectiveFactors' className='add-only'>
                                <option value='NA'> </option>
                                <option value='Positive social support'> Positive social support </option>
                                <option value='Cultural/religious beliefs'> Cultural/religious beliefs </option>
                                <option value='Social responsibility'> Social responsibility </option>
                                <option value='Children in the home'> Children in the home </option>
                                <option value='Life satisfaction'> Life satisfaction </option>
                                <option value='Positive coping skills'> Positive coping skills </option>
                                <option value='Sufficient problem-solving skills'> Sufficient problem-solving skills </option>
                                <option value='Strong therapeutic rapport'> Strong therapeutic rapport </option>
                            </select>

                        </td>
                    </tr>

                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Additional Details:</span>
                    <textarea id='txtAdditionalDetails' name='txtAdditionalDetails' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Objective Content</span>
                    <textarea id='txtObjectiveContent' name='txtObjectiveContent' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <b>Biopsychosocial Assessment</b>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Identification:</span>
                    <textarea id='txtIdentification' name='txtIdentification' placeholder='age (13 at time of intake), ethnicity, religion, marital status, referral status,' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>History of Present Problem:</span>
                    <textarea id='txtHistoryPresentProblem' name='txtHistoryPresentProblem' placeholder='symptoms, onset, duration, frequency, etc.' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Psychiatric History:</span>
                    <textarea id='txtPsychiatricHistory' name='txtPsychiatricHistory' placeholder='prior episodes of symptoms, diagnoses, courses of treatment, etc.' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Trauma History:</span>
                    <textarea id='txtTraumaHistory' name='txtTraumaHistory' placeholder='nature of trauma, when occurred, persons involved, etc.' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Family Psychiatric History:</span>
                    <textarea id='txtFamilyPsychiatricHistory' name='txtFamilyPsychiatricHistory' placeholder='history of mental illness in family, diagnoses, etc.' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Medical Conditions & History:</span>
                    <textarea id='txtMedicalConditionsHistory' name='txtMedicalConditionsHistory' placeholder='current and past medical conditions, treatments, allergies, etc.' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Current Medications:</span>
                    <textarea id='txtCurrentMedications' name='txtCurrentMedications' placeholder='medication, dosage, purpose, prescribing physician' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Substance Use:</span>
                    <textarea id='txtSubstanceUse' name='txtSubstanceUse' placeholder='history of substances used, including alcohol, tobacco, and prescription' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Family History:</span>
                    <textarea id='txtFamilyHistory' name='txtFamilyHistory' placeholder='family of origin, relationship with parents, siblings, significant others, etc.' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Social History:</span>
                    <textarea id='txtSocialHistory' name='txtSocialHistory' placeholder='significant relationships, social support, nature/quality of relationships,' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Spiritual/Cultural Factors:</span>
                    <textarea id='txtSpiritualCulturalFactors' name='txtSpiritualCulturalFactors' placeholder='important spiritual practices and communities, cultural influences, etc.' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Developmental History:</span>
                    <textarea id='txtDevelopmentalHistory' name='txtDevelopmentalHistory' placeholder='developmental milestones, delays, etc.' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Educational/Vocational History:</span>
                    <textarea id='txtEducationalVocationalHistory' name='txtEducationalVocationalHistory' placeholder='level of education, current/past employment, hobbies, leisure activities,' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Legal History:</span>
                    <textarea id='txtLegalHistory' name='txtLegalHistory' placeholder='arrest/summons history, sentencing, DUI occurrences, incarceration, civil' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>SNAP:</span>
                    <textarea id='txtSNAP' name='txtSNAP' placeholder='strengths, needs, abilities, preferences, etc.' className='add-only'></textarea>
                </p>


                <p className='w-750'>
                    <span className='eleHeader'>Plan</span>
                    <textarea id='txtPlan' name='txtPlan' placeholder='next steps in treatment process, including further assessment if required and/or development of a full treatment plan' className='add-only'></textarea>


                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Diagnosis</span>

                    <input id='txtDiagnosisPrimary' name='txtDiagnosisPrimary' type='text' placeholder='Primary ICD-10' className='add-only w-200 custom-add-only' />
                    <input id='txtDiagnosisDescription' name='txtDiagnosisDescription' type='text' placeholder='description' className='add-only w-500 custom-add-only' />
                    <br />
                    <textarea id='txtDiagnosisDiagnosticJustification' name='txtDiagnosisDiagnosticJustification' placeholder='Diagnostic justification and/or assessment measures' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbDeclareation' name='cbDeclareation' className='add-only' value='Declareation' />
                    &nbsp;
                    Sign this Form: I,
                    <input type='text' id='txtName' name='txtName' className='add-only w-200 custom-add-only' />,
                    Licensed Clinical Professional Counselor,
                    License <input type='text' id='txtLicense' name='txtLicense' placeholder='License No.' className='add-only w-200 custom-add-only' />,
                    declare this information to be accurate and complete.

                </p>

            </div>
        </form>

    )
}